import { Directive, EventEmitter, HostBinding, HostListener, Output } from "@angular/core";

@Directive({ selector: "[file-drag-drop]" })
export class FileDragDropDirective {
    @Output() fileDropped = new EventEmitter<FileList>();
    @HostBinding("style.background") public background = "#eee";
    @HostBinding("style.border") public border = "2px dashed";
    @HostBinding("style.border-color") public borderColor = "#696D7D";
    @HostBinding("style.border-radius") public borderRadius = "5px";

    // Dragover listener, when something is dragged over host element
    @HostListener("dragover", ["$event"])
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        this.setDragOverStyle();
    }

    // Dragleave listener, when something is dragged away from host element
    @HostListener("dragleave", ["$event"])
    public onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        this.setDefaultStyle();
    }

    // when something is dropped on host element
    @HostListener("drop", ["$event"])
    public ondrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        let files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }

        this.setDefaultStyle();
    }

    setDefaultStyle() {
        this.background = "#eee";
        this.border = "2px dashed";
        this.borderColor = "#696D7D";
        this.borderRadius = "5px";
    }

    setDragOverStyle() {
        this.background = "lightgray";
        this.border = "3px solid";
        this.borderColor = "cadetblue";
        this.borderRadius = "5px";
    }

    constructor() {
        this.setDefaultStyle();
    }
}
